import 'bootstrap/dist/css/bootstrap.css';
import React, { useEffect, useState } from 'react';
import { usePageSeo } from './usePageSeo';

import { useHomeContent } from './home/useHomeContent';
import { HeroSection } from './home/sections/HeroSection';
import { ProjectsSection } from './home/sections/ProjectsSection';
import { WhySection } from './home/sections/WhySection';
import { ServiceSection } from './home/sections/ServiceSection';
import { SoftwareSection } from './home/sections/SoftwareSection';

function Home() {
  usePageSeo('seo.home.title', 'seo.home.description');

  const [heroAutoHighlightIndex, setHeroAutoHighlightIndex] = useState(-1);
  const {
    projectColumns,
    softwareSlides,
    serviceItems,
    whyCards,
    heroCapabilities,
  } = useHomeContent();

  const [activeServiceId, setActiveServiceId] = useState('design');

  useEffect(() => {
    const totalBoxes = 5;
    const startDelayMs = 420;
    const stepMs = 360;
    const timers = [];

    for (let index = 0; index < totalBoxes; index += 1) {
      const timer = setTimeout(() => {
        setHeroAutoHighlightIndex(index);
      }, startDelayMs + (index * stepMs));
      timers.push(timer);
    }

    const resetTimer = setTimeout(() => {
      setHeroAutoHighlightIndex(-1);
    }, startDelayMs + (totalBoxes * stepMs));
    timers.push(resetTimer);

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  useEffect(() => {
    if (!serviceItems.some((serviceItem) => serviceItem.id === activeServiceId)) {
      setActiveServiceId(serviceItems[0]?.id || 'design');
    }
  }, [serviceItems, activeServiceId]);

  const activeServiceItem = serviceItems.find((serviceItem) => serviceItem.id === activeServiceId) || serviceItems[0];

  return (
    <span id="span-full-lenght">
      <div class="vb-page" id="home">
        <HeroSection
          heroAutoHighlightIndex={heroAutoHighlightIndex}
          heroCapabilities={heroCapabilities}
        />
        <ProjectsSection projectColumns={projectColumns} />
        <WhySection whyCards={whyCards} />
        <ServiceSection
          serviceItems={serviceItems}
          activeServiceId={activeServiceId}
          setActiveServiceId={setActiveServiceId}
          activeServiceItem={activeServiceItem}
        />
        <SoftwareSection softwareSlides={softwareSlides} />
      </div>
    </span>
  );
}

export default Home;
